import { Button } from "@/components/ui/button";
import SchadenKIStore from "@/stores/SchadenKIStore";
import MultiadapterStore from "@/stores/MultiadapterStore";
import DatenadapterStore from "@/stores/DatenadapterStore";
import { useTranslation } from "react-i18next";
import { useSchadenKICredentials } from "@/hooks/useSchadenKICredentials";
import { useMultiadapterCredentials } from "@/hooks/useMultiadapterCredentials";
import { useDatenadapterCredentials } from "@/hooks/useDatenadapterCredentials";

export function SaveSchadenKIButton() {
    const { t } = useTranslation();
    const hasSchadenKIChanges = SchadenKIStore(state => state.hasChanges);
    const hasMultiadapterChanges = MultiadapterStore(state => state.hasChanges);
    const hasDatenadapterChanges = DatenadapterStore(state => state.hasChanges);
    const { isLoading: schadenKILoading, handleSaveCredentials: saveSchadenKI } = useSchadenKICredentials();
    const { isLoading: multiadapterLoading, handleSaveCredentials: saveMultiadapter } = useMultiadapterCredentials();
    const { isLoading: datenadapterLoading, handleSaveCredentials: saveDatenadapter } = useDatenadapterCredentials();

    const hasChanges = hasSchadenKIChanges || hasMultiadapterChanges || hasDatenadapterChanges;
    const isLoading = schadenKILoading || multiadapterLoading || datenadapterLoading;

    const handleSave = async () => {
        if (hasSchadenKIChanges) {
            saveSchadenKI();
        }
        if (hasMultiadapterChanges) {
            saveMultiadapter();
        }
        if (hasDatenadapterChanges) {
            saveDatenadapter();
        }
    };

    return (
        <Button onClick={handleSave} className="w-full p-0 h-9" disabled={isLoading || !hasChanges}>
            {t("common.save")}
        </Button>
    );
}
